export enum NativeAppEvents {
  TokensRefreshed = 'tokens_refreshed',
}

type NativeAppMessageTemplate<T = undefined> = {
  event: NativeAppEvents;
} & (T extends undefined ? { data?: undefined } : { data: T });

type TokensRefreshedMessageData = {
  idToken: string;
  accessToken: string;
};

export type TokensRefreshedMessage = NativeAppMessageTemplate<TokensRefreshedMessageData> & {
  event: NativeAppEvents.TokensRefreshed;
};

export type NativeAppMessage = TokensRefreshedMessage;

export const nativeAppTokensRefreshed = ({
  idToken,
  accessToken,
}: TokensRefreshedMessage['data']): TokensRefreshedMessage => ({
  event: NativeAppEvents.TokensRefreshed,
  data: { idToken, accessToken },
});
